import { resolveCoverImageUrl } from '@/lib/cover-image';
import type { Book } from '@/services/catalog-api';

/* Non-component helpers for the collection vocabulary. Kept out of
   Collection.tsx so that file only exports components (fast refresh). */

export const searchHref = (book: Book) => `/catalog?search=${encodeURIComponent(book.title)}`;

/* author_names is a list in the API. A string is tolerated as well, because
   pages that build a Book by hand (Student.tsx) cast past the type. */
export const authorLine = (book: Book): string => {
  const names: unknown = book.author_names;
  const fromNames = Array.isArray(names) ? names.join(', ') : typeof names === 'string' ? names : '';
  return book.authors?.map((a) => a.full_name).join(', ') || fromNames || 'Unknown author';
};

/* Rating only when one exists: "0.0" on unreviewed books is a lie. */
export const bookRating = (book: Book): string | null => {
  const r = parseFloat(book.average_rating || '0');
  return r > 0 ? r.toFixed(1) : null;
};

export const getBookCoverSrc = (book: Book): string | null => {
  if (book.cover_image) return resolveCoverImageUrl(book.cover_image);
  if (book.isbn) {
    return `https://covers.openlibrary.org/b/isbn/${encodeURIComponent(book.isbn)}-L.jpg`;
  }
  return null;
};
